import { useSelector } from 'react-redux'
import { qrSelector } from '../../../redux/slices/qr'
import CountdownTime from '../../reusable/Dayjs/CountdownTime'
import Hdivider from '../../reusable/Dividers/Hdivider'
import KeyValueInfo from '../../reusable/Info/KeyValueInfo'
import QrId from '../../reusable/Qr/QrId'

const QrTicketsBlock = () => {
  const { orders } = useSelector(qrSelector)
  // const isAlmostExpired = false // true

  return (
    <div className="qr_tickets_block">
      {orders.map(({ id, city, sum, timeLeft }) => (
        <div key={id} className="qr_ticket">
          <div className="qr_info">
            <QrId id={id} />
            <KeyValueInfo infoKey="Місто" infoValue={city} />
            <KeyValueInfo infoKey="Вартість" infoValue={sum + ' UAH'} />
          </div>
          <Hdivider />
          <div className="exp_time">
            <KeyValueInfo
              infoKey="Залишилось"
              infoValue={<CountdownTime timestamp={timeLeft} />}
              spaceBtw
              // redValue={isAlmostExpired}
              boldValue
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default QrTicketsBlock
